<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <g>
    <path class="cls-4" d="m77.77,16.32v8.26H12.23v-8.26c0-2.25,1.84-4.09,4.09-4.09h57.35c2.25,0,4.09,1.84,4.09,4.09Z"/>
    <path class="cls-4" d="m78.94,25.75H11.06v-9.43c0-2.9,2.36-5.26,5.26-5.26h57.35c2.9,0,5.26,2.36,5.26,5.26v9.43Zm-65.54-2.34h63.2v-7.09c0-1.61-1.31-2.92-2.92-2.92H16.33c-1.61,0-2.92,1.31-2.92,2.92v7.09Z"/>
  </g>
  <path class="cls-5" d="m73.67,78.94H16.33c-2.9,0-5.26-2.36-5.26-5.26V23.41h67.87v50.27c0,2.9-2.36,5.26-5.26,5.26ZM13.4,25.75v47.93c0,1.61,1.31,2.92,2.92,2.92h57.35c1.61,0,2.92-1.31,2.92-2.92V25.75H13.4Z"/>
  <rect class="cls-5" x="54.75" y="24.58" width="2.34" height="53.19"/>
  <rect class="cls-5" x="32.91" y="24.58" width="2.34" height="53.19"/>
  <g>
    <line class="cls-2" x1="12.23" y1="42.31" x2="77.77" y2="42.31"/>
    <rect class="cls-5" x="12.23" y="41.14" width="65.54" height="2.34"/>
  </g>
  <g>
    <line class="cls-2" x1="12.23" y1="60.04" x2="77.77" y2="60.04"/>
    <rect class="cls-5" x="12.23" y="58.87" width="65.54" height="2.34"/>
  </g>
  <g>
    <circle class="cls-1" cx="45" cy="51.17" r="16.76"/>
    <path class="cls-2" d="m45,69.1c-9.89,0-17.93-8.04-17.93-17.93s8.04-17.93,17.93-17.93,17.93,8.04,17.93,17.93-8.04,17.93-17.93,17.93Zm0-33.53c-8.6,0-15.59,7-15.59,15.59s7,15.59,15.59,15.59,15.59-7,15.59-15.59-7-15.59-15.59-15.59Z"/>
  </g>
  <path class="cls-5" d="m54.53,57.1h-19.06c-.06,0-.12-.03-.16-.08-.04-.05-.04-.12-.02-.18.12-.33.16-.69.09-1.05-.14-.81-.81-1.44-1.59-1.48-.23-.02-.45.02-.65.09-.06.02-.13.01-.18-.02-.05-.04-.08-.1-.08-.16v-6.09c0-.06.03-.12.08-.16.05-.04.12-.05.18-.02.21.08.43.11.65.09.78-.05,1.44-.67,1.59-1.48.06-.36.03-.72-.09-1.05-.02-.06-.01-.13.02-.18.04-.05.1-.08.16-.08h19.06c.06,0,.12.03.16.08.04.05.04.12.02.18-.08.22-.13.45-.13.69,0,1.02.77,1.84,1.72,1.84.19,0,.37-.03.55-.1.06-.02.13-.01.18.02.05.04.08.1.08.16v6.09c0,.06-.03.12-.08.16-.05.04-.12.05-.18.02-.18-.06-.36-.1-.55-.1-.95,0-1.72.83-1.72,1.84,0,.24.04.47.13.69.02.06.01.13-.02.18-.04.05-.1.08-.16.08Zm-18.79-.39h18.53c-.05-.18-.07-.37-.07-.57,0-1.23.95-2.23,2.11-2.23.14,0,.28.02.42.05v-5.57c-.14.03-.28.05-.42.05-1.16,0-2.11-1-2.11-2.23,0-.19.02-.38.07-.57h-18.53c.08.32.09.66.03.99-.17.99-.99,1.75-1.95,1.8-.19.01-.37,0-.55-.04v5.57c.18-.04.36-.05.55-.04.95.06,1.77.82,1.95,1.8.06.33.05.67-.03.99Z"/>
  <path class="cls-3" d="m57.22,58.22h-24.44c-.55,0-1-.49-1-1.09v-11.91c0-.6.45-1.09,1-1.09h24.44c.55,0,1,.49,1,1.09v11.91c0,.6-.45,1.09-1,1.09Zm-24.44-13.58c-.27,0-.48.26-.48.57v11.91c0,.32.22.57.48.57h24.44c.27,0,.48-.26.48-.57v-11.91c0-.32-.22-.57-.48-.57h-24.44Z"/>
  <g>
    <path class="cls-3" d="m45.83,50.54l-1.1-.24c-.29-.07-.49-.15-.6-.24-.11-.09-.16-.21-.16-.35,0-.16.08-.3.25-.41.16-.11.44-.16.85-.16.4,0,.8.06,1.19.18.39.12.72.28,1.01.49l.51-1.39c-.26-.19-.58-.35-.96-.48-.37-.12-.77-.21-1.19-.25v-1.07s-1.34-.01-1.34-.01v1.12c-.6.11-1.09.34-1.46.71-.37.37-.56.83-.56,1.38,0,1,.59,1.64,1.81,1.91l1.1.25c.28.06.47.15.58.23.11.09.16.2.16.33,0,.19-.1.35-.29.48-.19.12-.45.18-.79.18-.36,0-.7-.06-1.02-.16-.32-.1-.59-.25-.82-.43l-.49,1.3c.2.18.45.34.76.46.31.12.63.21.97.25v1.09s1.34.01,1.34.01v-1.12c.63-.11,1.12-.36,1.49-.73.37-.38.56-.84.56-1.38,0-1.03-.58-1.68-1.78-1.95Z"/>
    <path class="cls-5" d="m52.37,52.65c-.82,0-1.48-.67-1.48-1.48s.67-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48Zm0-2.71c-.67,0-1.22.55-1.22,1.22s.55,1.22,1.22,1.22,1.22-.55,1.22-1.22-.55-1.22-1.22-1.22Z"/>
    <path class="cls-5" d="m37.63,52.65c-.82,0-1.48-.67-1.48-1.48s.67-1.48,1.48-1.48,1.48.66,1.48,1.48-.66,1.48-1.48,1.48Zm0-2.71c-.67,0-1.22.55-1.22,1.22s.55,1.22,1.22,1.22,1.22-.55,1.22-1.22-.55-1.22-1.22-1.22Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "DollarsTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #fff;
  }
  .cls-2 {
    fill: #0f5b71;
  }
  .cls-3 {
    fill: #b3decd;
  }
  .cls-4 {
    fill: #115c72;
  }
  .cls-5 {
    fill: #59c5c7;
  }
</style>